import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/main.ts